import { apiClient } from './client';

export const aiApi = {
  summarize: async (ticketId: string) => {
    const res = await apiClient.post('/ai/summarize', { ticketId });
    return res.data.data.summary as string;
  },

  categorize: async (text: string) => {
    const res = await apiClient.post('/ai/categorize', { text });
    return res.data.data as { category: string; categoryId?: string; tags: string[]; priority: string };
  },

  suggestReply: async (ticketId: string) => {
    const res = await apiClient.post('/ai/suggest-reply', { ticketId });
    return res.data.data.suggestedReply as string;
  },

  kbMatch: async (text: string) => {
    const res = await apiClient.post('/ai/kb-match', { text });
    return res.data.data.matches as any[];
  },

  sentiment: async (text: string) => {
    const res = await apiClient.post('/ai/sentiment', { text });
    return res.data.data.sentiment as string;
  },

  duplicates: async (title: string, description?: string) => {
    const res = await apiClient.post('/ai/duplicates', { title, description });
    return res.data.data.duplicates as any[];
  },

  sanitizeTitle: async (ticketId: string) => {
    const res = await apiClient.post('/ai/sanitize-title', { ticketId });
    return res.data.data.suggestedTitle as string;
  },

  /** Turn a natural-language question into ticket-list filters. Only the
   *  question and the workspace vocabulary reach the AI provider — never
   *  ticket content. */
  searchQuery: async (question: string) => {
    const res = await apiClient.post('/ai/search-query', { question });
    return res.data.data as SearchQueryResult;
  },
};

export interface SearchQueryResult {
  filters: {
    search?: string;
    status?: string;
    statusCategory?: string;
    priority?: string;
    type?: string;
    assignedTo?: string;
    categoryId?: string;
    productLineId?: string;
    createdAfter?: string;
    createdBefore?: string;
    sort?: string;
  };
  /** Chips describing what the question was understood to mean. */
  applied: { label: string; value: string }[];
  /** Parts of the question that matched nothing in this workspace. */
  unmapped: string[];
  explanation?: string;
}
